import { Box } from '@mui/system';
import { ClientSchemaType, ModalBase } from 'remote/global';
import MyClientsRequestForm from '../forms/B2BFactory/MyClientsRequestForm';

type ModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>; // Used to change the open state
  onClose: () => void; // Used to clear the open and component state
  onSubmitSuccess: (data: ClientSchemaType) => void;
  isEditMode?: boolean;
  defaultValues?: ClientSchemaType;
};

function AddNewClientModal(props: ModalProps) {
  const { open, setOpen, onClose } = props;

  const handleCloseModal = () => {
    setOpen(false);
    onClose();
  };

  return (
    <ModalBase
      open={open}
      title='Add new client'
      setOpen={setOpen}
      onClose={handleCloseModal}
      maxWidth='md'
      fullWidth
    >
      <Box p={2} maxWidth={400} mx='auto'>
        <MyClientsRequestForm {...props} />
      </Box>
    </ModalBase>
  );
}

export default AddNewClientModal;
